module.exports = __webpack_public_path__ + "img/logo_03.df6b9d7e.png";